import type { Game } from 'model/game/types';

/**
 * Get the timestamp from a JCE node.
 */
export function getTimestampFromNode(node: Game.Move.Node): number | null {
  if (!node.commands?.timestamp) {
    return null;
  }

  return parseInt(node.commands.timestamp, 10);
}
